module.exports = __webpack_public_path__ + "img/furnitureshop-reward.db1e1165.png";